import { Attr } from './Attr';
import { Defaults } from './Defaults';
export var Column;
(function (Column) {
    function make(name, source, type, role, scale, dataType, dataRole, opts = {}) {
        switch (role) {
            case "DIMENSION": {
                const attr = Attr.dimension(source, dataType, dataRole);
                switch (type) {
                    case "DISCRETE":
                        switch (scale) {
                            case "ORDINAL":
                                return ordinal(attr, name, type, role, opts);
                            default:
                                return categorical(attr, name, opts);
                        }
                    case "CONTINUOUS":
                        return ordinal(attr, name, type, role, opts);
                }
            }
            case "MEASURE": {
                const attr = Attr.Measure.make(source, dataType, dataRole);
                switch (type) {
                    case "DISCRETE":
                        return ordinal(attr, name, type, role, opts);
                    case "CONTINUOUS": {
                        return quantitative(attr, name, opts);
                    }
                }
            }
            default:
                throw new Error(`Cannot create column with role ${role}`);
        }
    }
    Column.make = make;
    function categorical(formula, name, opts = {}) {
        const source = "COLUMN";
        const defaults = Defaults.make(formula.type, opts.defaults);
        return {
            ...Attr.categorical(formula, name, opts),
            source,
            defaults,
        };
    }
    Column.categorical = categorical;
    function ordinal(formula, name, type, role, opts = {}) {
        const source = "COLUMN";
        const defaults = Defaults.make(formula.type, opts.defaults);
        return {
            ...Attr.ordinal(formula, name, type, role, opts),
            source,
            defaults,
        };
    }
    Column.ordinal = ordinal;
    function quantitative(formula, name, opts = {}) {
        const source = "COLUMN";
        const defaults = Defaults.make(formula.type, opts.defaults);
        return {
            ...Attr.quantitative(formula, name, opts),
            source,
            defaults,
        };
    }
    Column.quantitative = quantitative;
    function merge(orig, column) {
        return [Merge.scale, Merge.role, Merge.type].reduce((value, transform) => {
            return transform(orig, value);
        }, orig);
    }
    Column.merge = merge;
    let Merge;
    (function (Merge) {
        function scale(orig, column) {
            const { formula, name, defaults, desc } = orig;
            switch (column.scale) {
                case "CATEGORICAL": {
                    return Column.categorical(formula, name, { defaults, desc });
                }
                case "ORDINAL": {
                    switch (orig.scale) {
                        case "CATEGORICAL":
                            return Column.ordinal(formula, name, orig.type, orig.role, {
                                desc,
                            });
                        case "ORDINAL":
                        case "QUANTITATIVE":
                            const { order } = orig;
                            return Column.ordinal(formula, name, orig.type, orig.role, {
                                desc,
                                order,
                            });
                    }
                }
                case "QUANTITATIVE": {
                    switch (formula.type.name) {
                        case "FLOAT":
                        case "INTEGER":
                        case "DECIMAL":
                        case "STRING":
                            const measure = Attr.measure(formula.source, formula.type, formula.role);
                            switch (orig.scale) {
                                case "CATEGORICAL":
                                    return Column.quantitative(measure, name, { desc });
                                case "ORDINAL":
                                case "QUANTITATIVE":
                                    const { order } = orig;
                                    return Column.quantitative(measure, name, { desc, order });
                            }
                        default:
                            return { ...orig };
                    }
                }
            }
        }
        Merge.scale = scale;
        function role(orig, column) {
            const { role } = column;
            switch (role) {
                case "DIMENSION": {
                    switch (orig.scale) {
                        case "CATEGORICAL":
                        case "ORDINAL":
                            return { ...orig, role };
                        default:
                            return { ...orig };
                    }
                }
                case "MEASURE": {
                    switch (orig.scale) {
                        case "ORDINAL":
                        case "QUANTITATIVE":
                            switch (orig.formula.type.name) {
                                case "FLOAT":
                                case "INTEGER":
                                case "DECIMAL":
                                case "STRING":
                                    return { ...orig, role };
                                default:
                                    return { ...orig };
                            }
                        default:
                            return { ...orig };
                    }
                }
            }
        }
        Merge.role = role;
        function type(orig, column) {
            const { type } = column;
            switch (type) {
                case "CONTINUOUS": {
                    switch (orig.scale) {
                        case "ORDINAL":
                        case "QUANTITATIVE":
                            switch (orig.formula.type.name) {
                                case "FLOAT":
                                case "INTEGER":
                                case "DECIMAL":
                                    return { ...orig, type };
                                default:
                                    return { ...orig };
                            }
                        default:
                            return { ...orig };
                    }
                }
                case "DISCRETE": {
                    switch (orig.scale) {
                        case "CATEGORICAL":
                        case "ORDINAL":
                            return { ...orig, type };
                        default:
                            return { ...orig };
                    }
                }
            }
        }
        Merge.type = type;
    })(Merge = Column.Merge || (Column.Merge = {}));
})(Column || (Column = {}));
